import { render } from "./add-exam.vue?vue&type=template&id=0606ee69"
import script from "./add-exam.vue?vue&type=script&lang=js"
export * from "./add-exam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__